var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Highcharts',{ref:"highcharts",attrs:{"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }